import Controller from '@ember/controller'
import { tracked } from '@glimmer/tracking'

export default class ReportingUiScopeMathsStudentSummaryIndexController extends Controller {
  queryParams = ['drivingTestsGrade']

  @tracked drivingTestsGrade = 0

  setDrivingTestsGrade = (dtGrade: number) => {
    this.drivingTestsGrade = dtGrade
  }
}
